module.exports = __webpack_public_path__ + "img/pescado.b227c9f8.svg";